// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rWxg2t6hnSC35s {
  width: fit-content;
  margin: 0;
  font-weight: normal;
  cursor: pointer;
}
.YG0PzeE5mufwC7 {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 24px;
}
.YG0PzeE5mufwC7 > input {
  opacity: 0;
}
.YG0PzeE5mufwC7 > input:checked + span {
  background-color: var(--ds-text-accent-green, #216e4e);
}
.YG0PzeE5mufwC7 > input:checked + span::before {
  transform: translateX(22px);
}
.YG0PzeE5mufwC7 > input:focus + span {
  outline: auto 5px var(--ds-border-selected, #0c66e4);
}
.YG0PzeE5mufwC7 > span {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: 0.4s;
  border-radius: 3px;
  background-color: var(--ds-background-accent-gray-subtle, #8590a2);
  cursor: pointer;
}
.YG0PzeE5mufwC7 > span::before {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 4px;
  width: 10px;
  height: 16px;
  transition: 0.4s;
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `rWxg2t6hnSC35s`,
	"switch": `YG0PzeE5mufwC7`
};
export default ___CSS_LOADER_EXPORT___;
